import PropTypes from 'prop-types';

const OvertimeMarkedWeek = {
  id: PropTypes.number,
  employeeId: PropTypes.number,
  lastMarkedWeek: PropTypes.string,
};

export default OvertimeMarkedWeek;
